export class PortCallStatusTypes {
  static AWAITING_CLEARANCE = 'Awaiting Clearance';
  static DRAFT = 'Draft';
  static CANCELLED = 'Cancelled';
  static COMPLETED = 'Completed';
  static CLEARED = 'Cleared';

  static DRAFT_ID = 100235;
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/port-call-status-types.ts